import { IOption } from './radarTypes';

export const RANGE_MAX = 5; // 坐标范围 0~5

export const defaults: IOption = {
    size: 100,
    chartSize: 0,
    axes: true,
    scales: 5,
    captions: true,
    captionsPosition: 1.36,
    axisProps: () => ({ className: 'axis' }),
    scaleProps: () => ({ className: 'scale', fill: 'none' }),
    shapeProps: () => ({ className: 'shape' }),
    captionProps: () => ({
        className: 'caption',
        textAnchor: 'middle',
        fontSize: 4,
        fontFamily: 'sans-serif',
    }),
};

export const polarToX = (angle: number, distance: number) => {
    return Math.cos(angle - Math.PI / 2) * distance;
};

export const polarToY = (angle: number, distance: number) => {
    return Math.sin(angle - Math.PI / 2) * distance;
};
